<template>
    <section class="questionwrapper">
      <div class="helper-holder">
       <p>Where do you see yourself<br>in 5 years?</p>

        <select id="selectmenu" v-model="watchedPath">
            <!--<option value="">Pick a path</option>-->
            <option value="backpacking">🌍 Backpacking</option>
            <option value="throne">👑 On the Iron Throne</option>
            <option value="job">💼 In your position</option>
            <option value="island">🌴 On a tropical island</option>
        </select>
        <label for="selectmenu">Pick a path</label>
        <!--<p>watched {{ this.watchedPath }}</p>-->
      </div>
    </section>
</template>

<script>
export default {
  data: function () {
    return {
      watchedPath: 'backpacking'
    };
  },
  methods: {
    sendPath: function () {
      this.$emit('update-answer-five', this.watchedPath);
    }
  },
  watch: {
    watchedPath: function () {
      this.sendPath();
      // console.log(this.watchedPath);
      // console.log(this.watchedPath);
      return this.watchedPath;
    }
  }
};
</script>

<style>

</style>
